import { gql } from "apollo-boost"

export const getCommentsSubmission = gql`
  query CommentsSubmission($entities: [CommentEntitiesInputType!]!) {
    CommentsSubmission(entities: $entities) {
      id
      fieldName
      userRol
      User
      createdAt
      reviewed
      revision
      comment
      type
      submission
      parentCommentId
    }
  }
`